<template>
  <label
    :class="className"
    :data-error="invalid"
  >
    <input
      placeholder=" "
      :value="value"
      v-bind="$attrs"
      @input="emitInput"
    >
    <span class="base-field__text-label"><slot /></span>
  </label>
</template>

<script>
export default {
  name: 'BaseField',
  inheritAttrs: false,
  props: {
    invalid: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    className() {
      return this.invalid ? 'base-field invalid' : 'base-field'
    }
  },
  methods: {
    emitInput({target}) {
      this.$emit('input', target.value )
    }
  }
}
</script>
<style lang="scss">
.base-field {
  --border-color: #E4E4E4;
  --gap: 8px;
  --invalid-color: #DB4835;
  --font-color: #333;

  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  max-width: 361px;
  margin: var(--gap) 0;

  input[type='text'],
  input[type='email'],
  input[type='date'],
  input[type='tel'],
  {
    box-sizing: border-box;
    width: 100%;
    padding: var(--gap);
    color: var(--font-color);
    font-weight: 400;
    font-size: 16px;
    line-height: 1.4;
    background-color: #FFFFFF;
    border: 1px solid var(--border-color);
    border-radius: 3px;
    outline: none;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &::placeholder {
      visibility: hidden;
    }
  }

  &__text-label {
    position: absolute;
    top: 50%;
    left: 0;
    color: #D0C9C0;
    transform: translate(var(--gap), -50%);
    transition: transform .3s, opacity .3s, font-size .2s;
  }

  &:focus-within &__text-label,
  input[type='text']:not(:placeholder-shown) ~ &__text-label,
  input[type='email']:not(:placeholder-shown) ~ &__text-label,
  input[type='date']:not(:placeholder-shown) ~ &__text-label,
  input[type='tel']:not(:placeholder-shown) ~ &__text-label,
  {
    color: var(--font-color);
    font-size: 12px;
    transform: translate(0, calc(-100% - 20px));
  }

  input[type='text']:required ~ &__text-label,
  input[type='email']:required ~ &__text-label,
  input[type='date']:required ~ &__text-label,
  input[type='tel']:required ~ &__text-label,
  {
    &::after {
      color: var(--invalid-color);
      content: ' *';
    }
  }

  input[type='text']:disabled ~ &__text-label,
  input[type='email']:disabled ~ &__text-label,
  input[type='date']:disabled ~ &__text-label,
  input[type='tel']:disabled ~ &__text-label,
  {
    cursor: not-allowed;

    &::after {
      opacity: 0.5;
    }
  }

  &:hover input[type='text']:not(:disabled),
  &:hover input[type='email']:not(:disabled),
  &:hover input[type='date']:not(:disabled),
  &:hover input[type='tel']:not(:disabled),
  &:focus-within input[type='text']:not(:disabled),
  &:focus-within input[type='email']:not(:disabled),
  &:focus-within input[type='date']:not(:disabled),
  &:focus-within input[type='tel']:not(:disabled),
  {
    --border-color: #E0B453;
  }

  &.invalid {
    --border-color: var(--invalid-color);

    & input[type='text']:hover,
    & input[type='email']:hover,
    & input[type='date']:hover,
    & input[type='tel']:hover,
    & input[type='text']:focus-within,
    & input[type='email']:focus-within,
    & input[type='date']:focus-within,
    & input[type='tel']:focus-within,
    {
      --border-color: var(--invalid-color);
    }

    &::after {
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      color: var(--border-color);
      font-size: 12px;
      content: attr(data-error);
    }
  }
}

</style>
